import React from 'react'
import { fetchAccessToken, validateUser, resetPassword } from '../login.service'
import styles from '../../styles.module.css'
import { MessageType } from '../constant'
import { NotificationComponent } from '../../Components/notificationWrapper/notificationWrapper'
import { Loader } from '../../Components/loader/loaderView'

class UserLogin extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      username: '',
      resetUsername: '',
      password: '',
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      loading: false,
      reset: false,
      errMsg: '',
      confirmErrMsg: '',
      disabled: true
    }
  }

  onSubmit = () => {
    if (this.state.username.trim() && this.state.password) {
      this.setState({
        loading: true
      })
      validateUser(this.state.username.trim(), this.state.password)
        .then((response) => {
          if (response.data && response.data.status !== 'UNAUTHORIZED') {
            fetchAccessToken(
              response.data.username.trim(),
              response.data.password
            ).then((response) => {
              if (response) {
                this.setState({
                  loading: false
                })
                this.props.onLoginSuccess(response)
              }
            })
          }
        })
        .catch((err) => {
          this.setState({
            loading: false
          })
          this._addNotification(
            MessageType.ERROR,
            err.response.data.error_description || err.response.data.message
          )
          if (
            err.response.data.message ===
            'Password expired, please change your password'
          ) {
            this.resetPassword()
          }
        })
    } else {
      this.setState({
        loading: false
      })
      this._addNotification(MessageType.ERROR, 'Enter User Id and Password')
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem
  }

  /**
   * Used to show Notifications
   * @param  type Type of Notification
   * @param  msg   Message to Show
   */
  _addNotification(type, msg) {
    this._notificationSystem._addNotification(type, msg)
  }

  resetPassword() {
    this.setState({
      reset: true
    })
    this.props.onBackFromUser(true)
  }

  onResetPassword = () => {
    this.setState({
      loading: true
    })
    if (
      this.state.resetUsername.trim() &&
      this.state.newPassword &&
      this.state.confirmPassword &&
      this.state.oldPassword
    ) {
      resetPassword(
        this.state.resetUsername.trim(),
        this.state.oldPassword,
        this.state.newPassword
      )
        .then((response) => {
          this.setState({
            reset: false,
            loading: false,
            username: '',
            password: '',
            resetUsername: '',
            oldPassword: '',
            confirmPassword: ''
          })
          this.props.onBackFromUser(false)
          this._addNotification(
            MessageType.SUCCESS,
            response.data || 'Password Reset,Login Again!'
          )
        })
        .catch((err) => {
          this.setState({
            loading: false
          })
          this._addNotification(
            MessageType.ERROR,
            err.response.data.error_description ||
              err.response.data.message ||
              'Not allowed'
          )
        })
    } else {
      this.setState({
        loading: false
      })
      this._addNotification(MessageType.ERROR, 'Please Enter Details')
    }
  }

  handleValidation = (evnt) => {
    const passwordInputValue = evnt.target.value.trim()
    const passwordInputFieldName = evnt.target.name
    if (passwordInputFieldName === 'newPassword') {
      const uppercaseRegExp = /(?=.*?[A-Z])/
      const lowercaseRegExp = /(?=.*?[a-z])/
      const digitsRegExp = /(?=.*?[0-9])/
      const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/
      const minLengthRegExp = /.{10,}/
      const passwordLength = passwordInputValue.length
      const uppercasePassword = uppercaseRegExp.test(passwordInputValue)
      const lowercasePassword = lowercaseRegExp.test(passwordInputValue)
      const digitsPassword = digitsRegExp.test(passwordInputValue)
      const specialCharPassword = specialCharRegExp.test(passwordInputValue)
      const minLengthPassword = minLengthRegExp.test(passwordInputValue)
      let errMsg = ''
      if (passwordLength === 0) {
        errMsg = 'Password is empty'
      } else if (!uppercasePassword) {
        errMsg = 'At least one Uppercase'
      } else if (!lowercasePassword) {
        errMsg = 'At least one Lowercase'
      } else if (!digitsPassword) {
        errMsg = 'At least one digit'
      } else if (!specialCharPassword) {
        errMsg = 'At least one Special Characters'
      } else if (!minLengthPassword) {
        errMsg = 'At least minumum 10 characters'
      } else {
        errMsg = ''
      }
      this.setState({
        errMsg: errMsg,
        disabled: errMsg.length
      })
    }
    if (
      passwordInputFieldName === 'confirmPassword' ||
      (passwordInputFieldName === 'newPassword' &&
        this.state.confirmPassword.length > 0)
    ) {
      if (this.state.confirmPassword !== this.state.newPassword) {
        this.setState({
          confirmErrMsg: 'Confirm password is not matched',
          disabled: true
        })
      } else {
        this.setState({
          confirmErrMsg: '',
          disabled: false
        })
      }
    }
  }

  render() {
    return (
      <div>
        {!this.state.reset && (
          <div>
            <Loader loading={this.state.loading} />
            {!this.state.loading && (
              <div>
                <div className={styles.UserLogin}>
                  <div>
                    <input
                      className={styles.label}
                      value={this.state.username}
                      onChange={(event) =>
                        this.setState({ username: event.target.value })
                      }
                      placeholder='Enter User Id'
                    />
                  </div>
                  <div>
                    <input
                      className={styles.label}
                      type='password'
                      value={this.state.password}
                      onChange={(event) =>
                        this.setState({ password: event.target.value })
                      }
                      placeholder='Enter Password'
                    />
                  </div>
                  <div className={styles.button_container}>
                    <button
                      className={styles.cstm_button}
                      onClick={this.onSubmit}
                    >
                      <a className={styles.btn_text}>Continue</a>
                    </button>
                  </div>
                  {!(this.props.hasResetPw == false) && (
                    <div className={styles.anchor_div}>
                      <div className={styles.anchor_text}>
                        Reset Password?
                        <span
                          className={styles.resendText}
                          onClick={() => this.resetPassword()}
                        >
                          Click Here
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
        {this.state.reset && (
          <div>
            <Loader loading={this.state.loading} />
            {!this.state.loading && (
              <div>
                <div className={styles.UserLogin}>
                  <div>
                    <input
                      className={styles.label}
                      value={this.state.resetUsername}
                      onChange={(event) =>
                        this.setState({ resetUsername: event.target.value })
                      }
                      placeholder='Enter User Id'
                    />
                  </div>
                  <div>
                    <input
                      className={styles.label}
                      type='password'
                      value={this.state.oldPassword}
                      onChange={(event) =>
                        this.setState({ oldPassword: event.target.value })
                      }
                      placeholder='Enter Old Password'
                    />
                  </div>
                  <div>
                    <input
                      className={styles.label}
                      type='password'
                      value={this.state.newPassword}
                      onChange={(event) =>
                        this.setState({ newPassword: event.target.value })
                      }
                      onKeyUp={this.handleValidation}
                      placeholder='Enter New Password'
                      name='newPassword'
                    />
                  </div>
                  <div>
                    <input
                      className={styles.label}
                      type='password'
                      value={this.state.confirmPassword}
                      onChange={(event) =>
                        this.setState({ confirmPassword: event.target.value })
                      }
                      onKeyUp={this.handleValidation}
                      placeholder='Confirm New Password'
                      name='confirmPassword'
                    />
                  </div>
                  <span className={styles.errorText}>
                    {this.state.errMsg
                      ? this.state.errMsg
                      : this.state.confirmErrMsg}
                  </span>
                  <div className={styles.button_container}>
                    <button
                      className={styles.cstm_button}
                      onClick={this.onResetPassword}
                      disabled={
                        this.state.disabled ||
                        this.state.confirmErrMsg ||
                        this.state.errMsg
                      }
                    >
                      <a className={styles.btn_text}>Reset Password</a>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        <div className=' body-container'>
          <NotificationComponent ref='notificationSystem' />
        </div>
      </div>
    )
  }
}

export default UserLogin
